import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";

interface SignupModalProps {
  isOpen: boolean;
  onClose: () => void;
  type?: 'exchange' | 'owner';
}

export const SignupModal = ({ isOpen, onClose, type }: SignupModalProps) => {
  const { toast } = useToast();

  const handleExchangeClick = () => {
    toast({
      description: "Verrai reindirizzato al modulo di pre-iscrizione Domus Flexi. Per assistenza: customerservice@domusflexi.com",
      duration: 3000,
    });
    // Track GA4 event
    if (typeof window !== 'undefined' && (window as any).gtag) {
      (window as any).gtag('event', 'click_modulo_scambio_casa', {
        event_category: 'Pre-iscrizione',
        event_label: 'Domus Flexi - Modulo Scambio Casa'
      });
    }
    window.open('https://forms.gle/QCNhuVZUpHHubLCF6', '_blank');
    onClose();
  };

  const handleOwnerClick = () => {
    toast({
      description: "Verrai reindirizzato al modulo di pre-iscrizione Domus Flexi. Per assistenza: customerservice@domusflexi.com",
      duration: 3000,
    });
    // Track GA4 event
    if (typeof window !== 'undefined' && (window as any).gtag) {
      (window as any).gtag('event', 'click_modulo_proprietari', {
        event_category: 'Pre-iscrizione',
        event_label: 'Domus Flexi - Modulo Proprietari'
      });
    }
    window.open('https://docs.google.com/forms/d/e/1FAIpQLSfrCAi2tU8UpM3Xz4u_IehMwYtCzuEPDn1oJjd3h_W6LAG7DA/viewform?usp=header', '_blank');
    onClose();
  };

  // Auto-trigger form based on type prop
  if (isOpen && type) {
    if (type === 'exchange') {
      handleExchangeClick();
    } else if (type === 'owner') {
      handleOwnerClick();
    }
    return null;
  }

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-center text-xl font-bold mb-4">
            Grazie per il tuo interesse!
          </DialogTitle>
        </DialogHeader>
        
        <div className="text-center space-y-6">
          <p className="text-muted-foreground">
            Domus Flexi è in fase di test. Se vuoi partecipare, seleziona il tuo profilo e compila il modulo corrispondente.
          </p>
          
          <div className="space-y-4">
            <Button 
              onClick={handleExchangeClick}
              className="w-full bg-primary hover:bg-primary/90 text-primary-foreground py-6 text-lg"
              size="lg"
            >
              🏠 Scambio Casa
            </Button>
            
            <Button 
              onClick={handleOwnerClick}
              variant="outline"
              className="w-full border-primary text-primary hover:bg-primary hover:text-primary-foreground py-6 text-lg"
              size="lg"
            >
              🏠 Sono un proprietario
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};